import { FunctionComponent } from 'react';

// Next
import { GetServerSideProps } from 'next';
import { NextSeoProps } from 'next-seo';

// Libs
import { getServerSideHttp } from '@Libs/http/cms';

// Components
import Layout from '@Pages/hoi-dap/Components/UI/Layout';
import AnswerDetail from '@Pages/hoi-dap/Components/UI/AnswerDetail';
import QuestionRelated from '@Pages/hoi-dap/Components/UI/QuestionRelated';

// @component
import { useViewDetected } from '@Components/Utils/ViewDetected';

// api
import newsFeedsdApi from '@Libs/api/cms/newsFeed';

// Styles
import styles from './Detail.module.scss';

// NPM
import classnames from 'classnames';

// Typescript
import Newsfeed from 'types/NewsFeed';

interface DetailPops {
    slug?: string;
    newsfeed?: Newsfeed;
}

const Detail: FunctionComponent<DetailPops> = ({ newsfeed, slug }) => {
    const { deviceType } = useViewDetected();

    const isMobile = deviceType !== 'desktop';
    const wrapperClassName = classnames([styles.wrapper, { [styles.mobile]: isMobile }]);

    const tags = newsfeed?.tags;
    const title = newsfeed?.title;
    const attachment = newsfeed?.attachment;
    const content = newsfeed?.question?.content; //** câu hỏi
    const questionComment = newsfeed?.question?.questionComment; //**  câu trả lời

    return (
        <Layout actionPage="detail">
            <div className={wrapperClassName}>
                <AnswerDetail
                    className={styles.answer}
                    {...{ tags, content, questionComment, attachment }}
                    titleNewsFeed={title}
                />
                <QuestionRelated slug={slug} />
            </div>
        </Layout>
    );
};

export default Detail;

export const getServerSideProps: GetServerSideProps = async (context) => {
    const cmsHttp = getServerSideHttp(context);
    const id: string | any = context?.params?.id || '';

    const response = await (async (): Promise<{ newsfeed: Newsfeed }> => {
        try {
            return await newsFeedsdApi(cmsHttp).getDetail(id);
        } catch (error) {
            return error;
        }
    })();

    const { newsfeed } = response || {};

    if (!newsfeed || !newsfeed.id) {
        return {
            notFound: true,
        };
    }

    if (newsfeed.slug && newsfeed.slug !== id) {
        return {
            redirect: {
                statusCode: 301,
                destination: `/hoi-dap/${newsfeed.slug}`,
            },
        };
    }

    const metadata = newsfeed?.metadata;
    const title = `eDoctor: ${newsfeed?.title || newsfeed?.question?.content?.substr(0, 150)}`;

    const seo: NextSeoProps = {
        title,
        openGraph: {
            title,
            type: 'article',
            description: newsfeed?.question?.content,
            ...(metadata?.description && { description: metadata?.description }),
            ...(metadata?.image && {
                images: Object.values(metadata.image.formats).map((image: any) => ({
                    alt: title,
                    url: image.url,
                    width: image.width,
                    height: image.height,
                })),
            }),
            article: {
                section: 'health',
                authors: ['eDoctor'],
            },
        },
    };

    return {
        props: { newsfeed, seo, slug: newsfeed.slug },
    };
};
